var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.545,
    height: 12.179
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ArrowRight_svg__arrow_right{fill:none;stroke:currentColor;stroke-linecap:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ArrowRight_svg__Group_1133",
    "data-name": "Group 1133",
    transform: "translate(1 1.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ArrowRight_svg__Path_240",
    "data-name": "Path 240",
    className: "ArrowRight_svg__arrow_right",
    d: "M-3552.079-8855.535h12.427",
    transform: "translate(3552.079 8860.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ArrowRight_svg__Path_241",
    "data-name": "Path 241",
    className: "ArrowRight_svg__arrow_right",
    d: "M0 0v6.612h6.612",
    transform: "rotate(-135 6.164 2.924)"
  }))));
};
export default SvgArrowRight;